module.exports = __webpack_public_path__ + "img/working.ae992aa6.gif";